import React from 'react';
import Slider from '../components/Slider'
import HomePhotos from '../data/home-carousel-content';

const HomePage = () => (
    <>
        {/* <h1>Welcome to Sidong Lei Lab</h1> */}
        <Slider photos={HomePhotos}/>
        <p className="paragraphContent">Our group’s research focuses on the mesoscopic investigation of transport phenomena, particularly, electric, thermal and thermoelectrical properties of low dimensional nanoscale materials. These materials include carbon nanotubes, organic and inorganic nanowires, 2-dimensional mesoscopic single crystals, and single organic molecules. The unique properties of these low dimensional systems are generally understood by considering enhanced quantum effects and increased correlations due to the reduction of available phase space. The use of modern state-of-the-art semiconductor device fabrication techniques and the development of new methods of material synthesis, manipulation, and characterization are essential parts of this research.</p>
    </>
    
)

export default HomePage;